export const LOCAL_STORAGE_AFFILIATE = 'affiliate';
export const LOCAL_STORAGE_AFFILIATES = 'affiliates';
